export default "__VITE_ASSET__Csddip4p__"